import { SicopMark } from '../SicopMark';
import { NavIcon } from './NavIcon';
import { NAV_ITEMS } from './navigation';
import type { ScreenId } from './navigation';
import { Avatar } from './UserBadge';
import type { ShellUser } from './UserBadge';

interface SidebarProps {
  current: ScreenId;
  onNavigate: (screen: ScreenId) => void;
  user: ShellUser;
  /** Ausente enquanto o login não está configurado. */
  onSignOut?: () => void;
}

/** Menu lateral do desktop. Compartilhado por todas as telas via AppShell. */
export function Sidebar({ current, onNavigate, user, onSignOut }: SidebarProps) {
  return (
    <aside className="bg-navy-950 desktop:flex hidden w-[248px] shrink-0 flex-col px-3.5 py-5 text-white">
      <div className="flex items-center gap-2.5 px-2.5 pt-1 pb-[18px]">
        <SicopMark size={34} variant="inverted" />
        <div>
          <div className="text-[16px] font-extrabold tracking-[1.5px]">SICOP</div>
          <div className="text-brand-100 text-[10px]">Tempo Telecom</div>
        </div>
      </div>

      <nav className="flex flex-1 flex-col gap-0.5 overflow-auto" aria-label="Menu principal">
        {NAV_ITEMS.map((item) => {
          const active = item.id === current;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onNavigate(item.id)}
              aria-current={active ? 'page' : undefined}
              className={`flex items-center gap-[11px] rounded-[10px] px-3 py-2.5 text-left text-[13.5px] font-semibold transition-colors ${
                active
                  ? 'text-navy-950 bg-white'
                  : 'text-navy-200 hover:bg-white/12 hover:text-white'
              }`}
            >
              <NavIcon path={item.icon} />
              <span className="flex-1">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="flex items-center gap-2.5 border-t border-white/15 pt-3">
        <button
          type="button"
          onClick={() => onNavigate('profile')}
          className="flex min-w-0 flex-1 items-center gap-2.5 rounded-[10px] text-left hover:opacity-85"
        >
          <Avatar name={user.name} picture={user.picture} size={34} />
          <div className="min-w-0 flex-1">
            <div className="truncate text-[13px] font-bold">{user.name}</div>
            <div className="text-brand-100 text-[10.5px]">{user.role}</div>
          </div>
        </button>

        {onSignOut ? (
          <button
            type="button"
            onClick={onSignOut}
            title="Sair"
            className="text-brand-100 p-1 hover:text-white"
          >
            <NavIcon path="M9 4H5v16h4M14 8l4 4-4 4M18 12H9" size={17} />
            <span className="sr-only">Sair da conta</span>
          </button>
        ) : null}
      </div>
    </aside>
  );
}
